import React from 'react'
import { FaCheckCircle, FaFileUpload, FaTruck, FaEye, FaTag } from 'react-icons/fa'
import PaymentProofStatusEnum from '@enums/PaymentProofStatusEnum'

interface PaymentProofCardProps {
  label: string
  proofStatus: PaymentProofStatusEnum | null | undefined
  proofUrl: string | null | undefined
  icon: 'sample' | 'transport'
  uploadMode?: boolean
}

const PaymentProofCard: React.FC<PaymentProofCardProps> = ({
  label,
  proofStatus,
  proofUrl,
  icon,
}) => {
  // Helper function to render status badge
  const renderStatusBadge = (status: PaymentProofStatusEnum | null | undefined) => {
    if (!status) return null

    const style = { backgroundColor: '', color: '#fff' }
    let text = ''
    switch (status) {
    case PaymentProofStatusEnum.PENDING:
      style.backgroundColor = '#E6EAF6'
      style.color = '#4d61aa'
      text = 'Em Análise'
      break
    case PaymentProofStatusEnum.APPROVED:
      style.backgroundColor = '#FA5A84'
      text = 'Aprovado'
      break
    case PaymentProofStatusEnum.REJECTED:
      style.backgroundColor = '#FFD6E3'
      style.color = '#FA5A84'
      text = 'Rejeitado'
      break
    default:
      style.backgroundColor = '#4d61aa'
      text = status as string
    }

    return (
      <div className="ml-lg-3 px-2 py-1" style={{
        ...style,
        borderRadius: '6px',
        display: 'inline-block',
        verticalAlign: 'middle',
      }}
      >
        <FaTag size={14} className="mr-1" style={{ marginTop: '-2px' }} />
        <span style={{
          fontWeight: 600,
          fontSize: '0.90em',
          lineHeight: 1.2,
          letterSpacing: '0.01em',
        }}
        >
          {text}
        </span>
      </div>
    )
  }

  return (
    <div className="box p-4 shadow-sm border-0 mb-3" style={{
      borderRadius: '12px',
      background: proofStatus
        ? 'linear-gradient(135deg, #4d61aa 0%, #6b7fc1 100%)'
        : 'linear-gradient(135deg, #e9ecef 0%, #f8f9fa 100%)',
      transition: 'all 0.3s ease'
    }}
    >
      {/* Header */}
      <div className="d-flex align-items-center align-items-md-center justify-content-between flex-column flex-md-row">
        <div className="flex-grow-1 mb-3 mb-md-0 w-100 w-md-auto">
          <div className="d-flex align-items-center mb-2">
            <div className="d-flex align-items-center justify-content-center" style={{
              width: '40px',
              height: '40px',
              borderRadius: '10px',
              background: proofStatus
                ? 'rgba(255, 255, 255, 0.25)'
                : 'rgba(0, 0, 0, 0.05)',
              marginRight: '14px'
            }}
            >
              {proofStatus === PaymentProofStatusEnum.APPROVED ? (
                <FaCheckCircle size={20} style={{ color: '#fff' }} />
              ) : icon === 'transport' ? (
                <FaTruck size={20} style={{
                  color: proofStatus ? '#fff' : '#6c757d'
                }}
                />
              ) : (
                <FaFileUpload size={20} style={{
                  color: proofStatus ? '#fff' : '#6c757d'
                }}
                />
              )}
            </div>
            <div className="d-flex flex-column flex-lg-row align-items-start align-lg-items-center flex-wrap" style={{ gap: '4px', flex: 1 }}>
              <h5 className="mb-0 font-weight-bold" style={{
                color: proofStatus ? '#fff' : '#495057',
                fontSize: '20px'
              }}
              >
                {label}
              </h5>
              {renderStatusBadge(proofStatus)}
            </div>
          </div>
          <p className="mb-0" style={{
            marginLeft: '54px',
            fontSize: '0.9rem',
            color: proofStatus ? 'rgba(255,255,255,0.9)' : '#6c757d',
            lineHeight: '1.5'
          }}
          >
            {proofStatus === PaymentProofStatusEnum.APPROVED
              ? 'Comprovante aprovado pelo financeiro'
              : proofStatus === PaymentProofStatusEnum.PENDING
                ? 'Comprovante enviado e em análise'
                : proofStatus === PaymentProofStatusEnum.REJECTED
                  ? 'Comprovante rejeitado. Envie novamente'
                  : 'Comprovante ainda não enviado'}
          </p>
        </div>
        {proofUrl && proofStatus && proofStatus !== PaymentProofStatusEnum.REJECTED && (
          <a
            href={proofUrl}
            target="_blank"
            rel="noreferrer"
            className="btn btn-lg px-4 px-md-5 py-3 w-100 w-md-auto"
            style={{
              background: '#fff',
              color: '#4d61aa',
              border: 'none',
              borderRadius: '10px',
              fontWeight: 'bold',
              fontSize: '1rem',
              cursor: 'pointer',
              transition: 'all 0.2s',
              boxShadow: '0 4px 12px rgba(77, 97, 170, 0.3)',
              maxWidth: '260px',
              flexShrink: 0,
              textDecoration: 'none',
            }}
          >
            <div className="d-flex align-items-center justify-content-center">
              <FaEye size={20} className="mr-2" />
              Ver Comprovante
            </div>
          </a>
        )}
      </div>
    </div>
  )
}

export default PaymentProofCard
